import styled, { css } from 'styled-components';
import { BKJButton } from '@bookjane2/bookjane-design-library';

export const SkillsTableScrollArea = styled.div`
  width: 100%;
  overflow-x: auto;
`;

export const SkillsTableRow = styled.div<{ $isHeader?: boolean; $hasEditColumns?: boolean }>`
  display: grid;
  grid-template-columns: ${({ $hasEditColumns }) =>
    $hasEditColumns ? '1fr 170px 170px 120px' : '1fr 170px'};
  min-width: ${({ $hasEditColumns }) => ($hasEditColumns ? '680px' : '420px')};
  gap: 8px;
  align-items: center;
  min-height: 72px;
  padding: 12px 16px;
  background-color: ${({ theme }) => theme.colors.White};
  border-bottom: 1px solid ${({ theme }) => theme.colors.Grey5};
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  ${({ theme }) => theme.typography.Body};

  &:nth-child(even) {
    background-color: ${({ theme }) => theme.colors.Grey1};
  }

  ${({ $isHeader, theme }) =>
    $isHeader &&
    css`
      min-height: 76px;
      padding: 24px 16px;
      border-bottom: 4px solid ${theme.colors.Grey4};
      ${theme.typography.Bold};
    `}
`;

export const CenteredCell = styled.div`
  text-align: center;
`;

export const EmptyStateMessage = styled.div`
  padding: 40px 0;
  text-align: center;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  ${({ theme }) => theme.typography.Body};
`;

export const UnderlineButton = styled(BKJButton)`
  color: ${({ theme }) => theme.colors.PrimaryDefault};
  text-decoration: underline;
  background-color: transparent;
  border: none;
  font-size: 16px;
  line-height: 24px;
  cursor: pointer;
  padding: 0px;
  justify-content: center;
`;

export const AllocationModalTitle = styled.div`
  ${({ theme }) => theme.fonts.PoppinsTextBold};
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  font-size: 20px;
  line-height: 28px;
`;

export const AllocationAppliedCount = styled.div`
  ${({ theme }) => theme.fonts.PoppinsTextBold};
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  font-size: 16px;
  line-height: 24px;
  padding: 10px 32px;
`;

export const AllocationLocationRow = styled.div`
  display: grid;
  grid-template-columns: 24px 1fr;
  gap: 16px;
  align-items: center;
  min-height: 70px;
  padding: 0 32px;
  border-top: 1px solid ${({ theme }) => theme.colors.Grey4};
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  ${({ theme }) => theme.typography.Body};
`;
